import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const PutRatioBackSpreadSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M30.3127 20.9829H15.8009L13.2221 24.6834L8.81378 18.0225" stroke="#A40C0C" strokeWidth="2"/>
    <path d="M8.81377 18.0225L1.28916 6.5508" stroke="#089981" strokeWidth="2"/>
</svg>)
const PutRatioBackSpread: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {PutRatioBackSpreadSvg(props)}
    </SvgIcon>
));
export default PutRatioBackSpread
